import api from "./api.js";

export default class OrderApi {
  static async getListOrder(params) {
    return await api.get(`api/order`, params);
  }

  static async getByIdOrder(orderId, params) {
    return await api.get(`api/order/${orderId}`, params);
  }

  // 판매취소
  static async updateCancelRequest(orderId, data) {
    return await api.patch(`api/order/cancel/request/${orderId}`, data);
  }

  // 취소승인
  static async updateCancelComplete(orderId, data) {
    return await api.patch(`api/order/cancel/complete/${orderId}`, data);
  }

  // 취소거절
  static async updateCancelReject(orderId, data) {
    return await api.patch(`api/order/cancel/reject/${orderId}`, data);
  }
}
